import {
  Description,
  DialogPanel,
  DialogTitle,
  Dialog as HeadlessDialog
} from '@headlessui/react'
import React from 'react'

type Props = Readonly<{
  open: boolean
  onClose: () => void
  children: React.ReactNode
  fullWidth?: boolean
}>

function Dialog({children, fullWidth = false, ...props}: Props) {
  return (
    <HeadlessDialog {...props} className="fixed inset-0 z-10 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center">
        <div id="dialog-overlay" className="fixed inset-0 bg-black/50" />
        <DialogPanel
          className={`relative mx-auto ${fullWidth ? 'w-fit' : 'w-full max-w-3xl'}`}
        >
          <div className="relative m-3 rounded-3xl bg-white p-8 md:p-12">
            {children}
          </div>
        </DialogPanel>
      </div>
    </HeadlessDialog>
  )
}

Dialog.Title = DialogTitle
Dialog.Description = Description

export default Dialog
